<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.general}}</div>
    </v-card-title>
    <template v-if="$mode !== 'ecics'">
      <v-card-title>
        <div class="body-2">{{labels.existingPolInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{labels.exClm}}</v-subheader>
              <div>{{motorForm.exClm ? 'Yes' : 'No'}}</div>
            </v-flex>
            <v-flex xs6 v-if="motorForm.exClm">
              <v-subheader class="queryLabel">{{labels.noClm}}</v-subheader>
              <div>{{motorForm.noClm}}</div>
            </v-flex>
            <v-flex xs6 v-if="motorForm.exClm">
              <v-subheader class="queryLabel">{{labels.clmAmt}}</v-subheader>
              <div>{{$store.state.agency.quotation.commonInfo.currPrefix}}{{formatDisplayNumber(motorForm.clmAmt)}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
    </template>
    <v-card-title>
      <div class="body-2">{{labels.existingPolInfo}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.ncdRate}}</v-subheader>
            <div v-if="motorForm.ncdPct !== null">{{motorForm.ncdPct}}%</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.exInsurer}}</v-subheader>
            <div v-if="motorForm.exInsurer !== null">{{motorForm.exInsurer}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.exPolNo}}</v-subheader>
            <div v-if="motorForm.exPolNo !== null">{{motorForm.exPolNo}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.exPolNoExp}}</v-subheader>
            <div v-if="motorForm.exPolNoExp !== null">{{formatDisplayDate(motorForm.exPolNoExp)}}</div>
            <div v-else> - </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        quoteInfo: 'Quotation Information',
        general: 'General',
        product: 'Product',
        busCls: 'Business Class',
        tariff: 'Tariff',
        cover: 'Type of Cover',
        startDate: 'Start Date',
        endDate: 'End Date',
        clmInfo: 'Claims Information',
        exClm: 'Claims in Past 3 Years?',
        noClm: 'No. of Claims',
        clmAmt: 'Total Claim Amount',
        ncdRate: 'Existing NCD',
        exInsurer: 'Existing Insurer',
        exPolNo: 'Existing Policy No.',
        exPolNoExp: 'Existing Policy No. Expiry',
        existingPolInfo: 'Existing Policy Information'
      }
    }
  },
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    motorForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  }
}
</script>

<style lang="scss">

</style>
